<template>
    <letter-layout
        title="有些遇见，从一开始就注定是遗憾"
        date="2026年6月1日"
        sign-date="2026年6月1日"
        :paragraphs="paragraphs"
    />
</template>

<script>
import LetterLayout from './letterLayout.vue';

export default {
    components: { LetterLayout },
    data() {
        return {
            paragraphs: [
                '有些遇见，从一开始就注定是遗憾。就像一场突如其来的雨，你撑着伞出现，陪我走了一段路，可走到路口，你轻轻说了一句再见，便转身消失在人海。我站在原地，连挽留都来不及说出口。',
                '曾经以为，只要真心相待，就能走到最后；曾经以为，只要足够坚持，就能换来长久；曾经以为，我们会有无数个明天，却忘了，有些人，光是遇见，就已经花光了所有运气。',
                '我们从无话不谈，走到无话可谈。从彻夜聊天，到慢慢沉默；从频繁分享，到不再打扰；从满心欢喜，到满眼失望。没有争吵，没有决裂，只是慢慢地，就淡了，远了，陌生了。',
                '最让人难过的，从来不是失去，而是曾经拥有。是那些一起走过的路，一起说过的话，一起许下的承诺，都还清晰地留在记忆里，可身边的人，却早已不在。',
                '后来我慢慢学会了沉默，学会了不纠缠，学会了把情绪藏在心底。我什么都想开了，什么都看淡了，可只有我自己知道，某个深夜，某首歌，某个熟悉的场景，还是会突然想起你，突然红了眼眶。',
                '原来，这世间最苦的，从来不是爱而不得，而是忘而不舍，是明明还在意，却只能装作无所谓；是明明还想念，却再也没有身份去问候；是明明还喜欢，却只能默默退场，互不打扰。',
                '只是，一个转身，就是一辈子；一次离别，就是后会无期。如果可以重来一次，我希望，我们不要相遇，不要相识，不要动心。'
            ]
        };
    }
};
</script>
